const normalizeWinnerEntry = (entry = {}) => {
  const winnerId = entry.winnerId || entry.nomineeId || entry.id || '';
  const winnerCode = entry.winnerCode || entry.nomineeCode || entry.code || '';
  const winnerText = entry.winnerText || entry.nomineeText || entry.text || entry.name || '';

  return {
    winnerId: String(winnerId || ''),
    winnerCode: String(winnerCode || ''),
    winnerText: String(winnerText || ''),
  };
};

export const getCategoryWinners = (category = {}) => {
  const winnerList = [
    ...(Array.isArray(category.winners) ? category.winners : []),
    ...(Array.isArray(category.tiedWinners) ? category.tiedWinners : []),
    ...(category.winner ? [category.winner] : []),
  ]
    .map(normalizeWinnerEntry)
    .filter((winner) => winner.winnerId || winner.winnerText || winner.winnerCode);

  const deduped = [];
  const seen = new Set();

  winnerList.forEach((winner) => {
    const key = winner.winnerId || `${winner.winnerCode}::${winner.winnerText}`;
    if (seen.has(key)) {
      return;
    }
    seen.add(key);
    deduped.push(winner);
  });

  return deduped;
};

export const getCategoryWinnerIds = (category = {}) => {
  return new Set(
    getCategoryWinners(category)
      .map((winner) => winner.winnerId)
      .filter(Boolean)
  );
};

export const getCategoryWinnersText = (category = {}) => {
  const texts = getCategoryWinners(category)
    .map((winner) => winner.winnerText)
    .filter(Boolean);

  return texts.join(' / ');
};
